export const SINGLE_MANGA_CALL_REQUEST = "SINGLE_MANGA_CALL_REQUEST";
export const SINGLE_MANGA_CALL_SUCCESS = "SINGLE_MANGA_CALL_SUCCESS";
export const SINGLE_MANGA_CALL_FAILURE = "SINGLE_MANGA_CALL_FAILURE";
